import { useSelector } from "react-redux";

export function useHasPermission(permissionKey) {
  const InitialPermissionData = useSelector(
    (state) => state.persistedReducer.forms.savedPermissions
  );

  const { permissions = [], roleName } = InitialPermissionData ?? {};

  if (roleName === "SUPER_ADMIN") return true;

  if (!permissions.length) return false;

  // Check if permissionKey matches either name or id
  const idToCheck = permissions.find(
    (p) => p.id === permissionKey || p.name === permissionKey
    
  )?.id;
  //console.log('permissions=================', permissions)
  if (!idToCheck) return false;

  return permissions.some((p) => p.id === idToCheck);
}

